/* eslint import/prefer-default-export: 0 */

export const citizenship = {
  intro: {
    title: 'Citizenship',
    body:
      'You will be asked questions about your citizenship status and history and be asked to provide details if necessary.',
  },
  pvq: {
    intro: {
      title: 'Citizenship',
      body:
        'You will be asked questions about your citizenship status and history and be asked to provide details if necessary.',
    },
    passportintro: {
      title: 'U.S. passport information',
      info: {
        text:
          'This section asks for information regarding your U.S. passport, if you have one. This information is one way we verify citizenship for U.S. citizens and travel to non-U.S. countries. If you have a U.S. passport book, passport card, or both, answer the questions for the most recently issued book or card you have. If you cannot find or you do not have access to your most recently issued passport book or card, answer the questions using the most recently issued one you have. For more information on U.S. passports, go to the U.S. State Department web site -- https://travel.state.gov/passport.',
        link: 'U.S. State Department passport help',
      },
    },
    passportbook: {
      question: {
        title: 'Have you ever had a U.S. passport book?',
        yes: 'Yes',
        no: 'No',
        explanation: 'Please explain.',
      },
      label: {
        number: 'What is the passport number on your passport book?',
        book: 'Passport',
        notApplicable: 'Unable to access passport',
        or: 'or',
        explanation: 'Please explain',
      },
      collection: {
        description: 'Summary of passports',
        appendTitle: 'Do you have any other active U.S. passport to report?',
        appendLabel: 'Add another U.S. passport',
        itemType: 'Passport Book',
      },
      name: 'What name is used on your passport book?',
      number: 'What is the passport number on your passport book?',
      issued: 'What is the issue date on your passport book?',
      expiration: 'What is the expiration date on your passport book?',
      status: {
        title: 'Is this your most recently issued passport book?',
        explanation: 'Please explain.',
      },
      help: {
        number: {
          title: 'Passport',
          message:
            'U.S. Passport numbers must be nine alphanumeric characters (letters and numbers).',
          note: '',
        },
        issued: {
          title: 'Use the exact date',
          message: 'Enter the date on your passport.',
          note: '',
        },
        expiration: {
          title: 'Use the exact date',
          message: 'Enter the date on your passport.',
          note: '',
        },
      },
      branch: {
        help: {
          title: 'Need more information about the U.S. passport?',
          message: 'Select whether you possess a U.S. passport',
          note: '',
        },
      },
      names: {
        reuse: 'Choose a previously used name',
      },
    },
    passportcard: {
      question: {
        title: 'Have you ever had a U.S. passport card?',
        yes: 'Yes',
        no: 'No',
        explanation: 'Please explain',
      },
      label: {
        number: 'What is the passport number on your passport card?',
        book: 'Passport',
        notApplicable: 'Unable to access passport card.',
        or: 'or',
        explanation: 'Please explain',
      },
      name: 'What name is used on your passport card?',
      number: 'What is the passport number on your passport card?',
      issued: 'What is the issue date on your passport card?',
      expiration: 'What is the expiration date on your passport card?',
      status: {
        title: 'Is this your most recently issued passport card?',
        explanation: 'Please explain.',
      },
      help: {
        number: {
          title: 'Passport',
          message:
            'U.S. Passport numbers must be nine alphanumeric characters (letters and numbers).',
          note: '',
        },
        issued: {
          title: 'Use the exact date',
          message: 'Enter the date on your passport.',
          note: '',
        },
        expiration: {
          title: 'Use the exact date',
          message: 'Enter the date on your passport.',
          note: '',
        },
      },
      branch: {
        help: {
          title: 'Need more information about the U.S. passport?',
          message: 'Select whether you possess a U.S. passport',
          note: '',
        },
      },
      names: {
        reuse: 'Choose a previously used name',
      },
    },
    status: {
      heading: {
        title: 'Citizenship status',
        citizenshipstatus: 'What is your citizenship status?',
        abroad: 'What document do you have proving you are a U.S. citizen born abroad?',
        documentnumber: {
          foreignborn: 'What is the serial number on your document?',
          notcitizen: 'What is the document number?',
        },
        documentissued: 'What is the issue date of your document?',
        placeissued: 'Was your document issued in the U.S.?',
        documentname: 'What is your name on this document?',
        whereIssued: 'Where was it issued?',
        certificatenumber: {
          foreignborn: 'Provide your Certificate of Citizenship number',
          naturalized: 'What is your Naturalization Certificate Number or Naturalization Number?',
          derived: 'What is your Citizenship Certificate Number or Citizenship Number?',
        },
        certificateissued: {
          foreignborn: 'Provide the date the certificate was issued',
          naturalized: 'What is the issue date of your Certificate of Naturalization?',
          derived: 'What is the issue date of your Certificate of Citizenship?',
        },
        certificatename: {
          foreignborn: 'Provide the name in which the certificate was issued',
          naturalized: 'What is your name on your Certificate of Naturalization?',
          derived: 'What is your name on your Certificate of Citizenship?'
        },
        certificatecourtname:
          'Provide the name of the court that issued the Certificate of Naturalization',
        certificatecourtaddress:
          'Provide the address of the court that issued the Certificate of Naturalization',
        bornonmilitaryinstallation: 'Were you born on an overseas U.S. military installation?',
        militarybase: 'What is the name of the overseas U.S. military installation?',
        entrydate: 'When did you enter the U.S.? (This is the date you entered the U.S. on your current visa.)?',
        entrylocation: 'Where did you enter the U.S.?',
        foreignBorn: {
          citizenship: 'Certificate of Citizenship',
          document: 'Document Information',
        },
        priorcitizenship: {
          naturalized: 'Provide country(ies) of prior citizenship',
          notcitizen: 'Provide country(ies) of citizenship.',
        },
        hasalienregistration: 'Do/did you have a U.S. alien registration number?',
        alienregistrationnumber: {
          naturalized:
            'What is your U.S. Alien Registration Number?',
          derived:
            'What is your U.S. Alien Registration Number?',
          notcitizen: 'What is your Alien Registration Number?',
        },
        alienregistrationexpiration: 'What is the expiration date of your document?',
        permanentresidentcardnumber: 'What is your Permanent Resident Card or Resident Alien Card number (Form I-551)?',
        residencestatus: 'What is your residence status?',
        documentexpiration: 'When does your Employment Authorization Card (Form I-766) expire?',
        documenttype: 'What document do you have verifying your legal residency?',
        form240date: 'Provide the date your State Department Form 240 was prepared',
        form240DateExplanation: 'Provide the explanation for the State Department Form 240',
        naturalized: {
          citizenship: 'Certificate of Citizenship',
          naturalization: 'Certificate of Naturalization',
          form240: 'State Department Form 240'
        },
        isResidentOfUnitedStates: 'Are you currently a resident of the U.S.?',
      },
      intro: {
        info: {
          text: 'This section asks for information regarding your citizenship. The information helps us verify U.S. citizenship -- an eligibility requirement for most federal, military, and national security positions and/or those performing work for or on behalf of the U.S. government to include employment authorization for non-U.S. citizens. If you are not a U.S. citizen, we use the requested information to verify you are authorized to work for or on behalf of the Federal Government. The United States (U.S.) is defined as the 50 U.S. states, the District of Columbia, and the U.S. territories.'
        },
      },
      label: {
        explanation: 'Please explain.',
        citizenshipstatus: {
          citizen:
            'I am a U.S. citizen by birth in the U.S. or U.S. territory/commonwealth',
          foreignborn:
            'I am a U.S. citizen by birth, born to U.S. parent(s), in a foreign country',
          foreignborn2013: 'I am a U.S. citizen, but I was NOT born in the U.S.',
          naturalized: 'I am a naturalized U.S. citizen',
          derived: 'I am a derived U.S. citizen',
          notcitizen: 'I am not a U.S. citizen',
          nationalByBirthInUs: 'I am a U.S. national by birth in the U.S. or a territory.',
          nationalByBirthOutsideUS: 'I am a U.S. national, born to U.S. parent(s), in a foreign country',
        },
        abroad: {
          fs240: 'FS-240',
          ds1350: 'DS-1350',
          fs545: 'FS-545',
          n560: 'N-560 or N-561',
          other: 'Other',
        },
        basis: {
          naturalized: 'Based on my own individual naturalization application',
          derived: 'By operation of law through my U.S. citizen parent',
          other: 'Other',
        },
        documenttype: {
          i94: 'I-94',
          visa: 'U.S. Visa (red foil number)',
          i20: 'I-20',
          ds2019: 'DS-2019',
          other: 'Other',
        },
        documentTypeOtherExplanation: 'What is the title of the form?'
      },
      help: {
        citizenshipstatus: {
          title: 'Need help with your citizenship status?',
          message: 'Select the box that reflects your current citizenship status',
          note: '',
        },
        abroad: {
          title: 'Need help with documentation of U.S. citizen born abroad?',
          message: 'Select the type of documentation',
          note: '',
        },
        documentnumber: {
          foreignborn: {
            title: 'Need help with the document number?',
            message: 'This is typically the number in the top right hand corner of your document (it is often in red ink).',
            note: '',
          },
          notcitizen: {
            title: 'Need help with the document number?',
            message: [
              'For the Form I-94, list the 11-digit number labeled either "Admission Number", "Departure Number", "Admission Record (I-94) Number", or "I-94#". Or, you may have an "Admission Stamp" in your unexpired foreign passport. If this is the case, also list your passport number and the country that issued the passport.',
              'For the U.S. Visa Card (nonimmigrant visa) -- the visa number, also called a visa foil number, is a red number that is generally printed on the bottom right corner of newer visa documents. In most cases, the U.S. visa number contains eight numeric characters. In some cases, the number contains one letter followed by seven numeric characters.',
              'For the Form I-20, list the "SEVIS ID" number near the top left or top right corner of the document (depending on the document version). All SEVIS ID numbers start with the letter N. If you also have an "Admission Number" on your Form I-20 document, list this number as well (this is your Form I-94 number).',
              'For the Form DS-2019, list the number on the top right hand side of the page in the box above the barcode. This is the SEVIS number. All SEVIS ID numbers start with the letter N.',
              'You can find their Alien Registration Number on their Permanent Resident Card/Resident Alien Card (Form I-551) or on their Employment Authorization Card (Form I-766), as applicable. Their Alien Registration Number may be listed as the "A#", "A" number, "INS A#", "Alien Number", or "USCIS#". On the Machine Readable Immigrant Visa (MRIV) Form I-551, it is the "Registration Number".'
            ],
            note: '',
          }
        },
        documentissued: {
          title: 'Need help with the date the documentation was issued?',
          message: 'Provide the approximate date the documenation was issued',
          note: '',
        },
        placeissued: {
          title: 'Need help with the place the documentation was issued?',
          message: 'Provide the place where the documentation was issued',
          note: '',
        },
        documentname: {
          title: 'Need help with the name on the documentation?',
          message: 'Provide the name on the documentation',
          note: '',
        },
        certificatenumber: {
          naturalized: {
            title: 'Need help with the certificate number?',
            message: 'This is the "No." (short for number) in the top right hand corner of your Certificate of Naturalization (N-550 or N-570) (it is often in red ink).',
            note: '',
          },
          derived: {
            title: 'Need help with the certificate number?',
            message: 'This is the "No." (short for number) in the top right hand corner of your Certificate of Citizenship (Form N-560 or Form N-561) It is often in red ink.',
            note: '',
          }
        },
        certificateissued: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        certificatename: {
          title: 'Need help with the name on the certificate?',
          message: 'Provide the name on the certificate',
          note: '',
        },
        bornonmilitaryinstallation: {
          title: 'Need help with if you were born on a military installation?',
          message: 'If you were born on a military installation select "yes"',
          note: '',
        },
        militarybase: {
          title: 'Need help with military base?',
          message: 'Provide the name of the military base',
          note: '',
        },
        entrydate: {
          title: 'Entry Date',
          message:
            'This is the date you entered the U.S. on your current visa.',
          note: '',
        },
        entrylocation: {
          title: 'Need help with the location of entry?',
          message: 'Provide the location of entry in to the U.S.',
          note: '',
        },
        priorcitizenship: {
          title: 'List all your prior citizenship(s)',
          message:
            'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
          note: '',
        },
        hasalienregistration: {
          title: 'Need help if you have an alien registration number?',
          message: 'If you have an alien registration number select "Yes"',
          note: '',
        },

        alienregistrationnumber: {
          naturalized: {
            title: 'Need help with your alien registration number?',
            message: [
              'You can find your Alien Registration Number on your Certificate of Naturalization (N-550 or N-570). It is a 7- to 9-digit number typically listed as the "USCIS Registration No.", "INS Registration No.", "CIS Registration No." It is not the "No." (short for number) in the top right hand corner often seen in red ink.',
              'You can also find your Alien Registration Number on your Permanent Resident Card/Resident Alien Card (Form I-551). It is a 7- to 9-digit number typically listed as the "A#", "INS A#", "Alien Number", or "USCIS#". On the Machine Readable Immigrant Visa (MRIV), it is the "Registration Number".'
            ],
            note: '',
          },
          derived: {
            title: 'Need help with your alien registration number?',
            message: [
              'If you have a Certificate of Citizenship (Form N-560 or Form N-561), your Alien Registration Number is the 7- to 9-digit number typically listed as the "USCIS Registration No.", "CIS Registration No.", or "INS Registration No.".',
              'If you do not have a Certificate of Citizenship, you can find your Alien Registration Number on your Permanent Resident Card/Resident Alien Card (Form I-551). It is a 7- to 9-digit number typically listed as the "A#", "INS A#", "Alien Number", or "USCIS#". On the Machine Readable Immigrant Visa (MRIV), it is the "Registration Number".'
            ],
            note: '',
          },
          notcitizen: {
            title: 'Need help with your alien registration number?',
            message: 'You can find your Alien Registration Number on your Permanent Resident Card/Resident Alien Card (Form I-551) or on your Employment Authorization Card (Form I-766), as applicable. Your Alien Registration Number may be listed as the "A#", "A" number, "INS A#", "Alien Number", or "USCIS#". On the Machine Readable Immigrant Visa (MRIV) Form I-551, it is the "Registration Number".)',
            note: '',
          }
        },
        alienregistrationexpiration: {
          title: 'Need help with your alien registration expiration date?',
          message: 'Provide the date of expiration for the alien registration',
          note: '',
        },
        certificatecourtname: {
          title: 'Need help with the court name?',
          message: 'Provide the court name',
          note: '',
        },
        certificatecourtaddress: {
          title: 'Try looking up the court name, this could help you find the address',
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        basis: {
          naturalized: {
            title: 'Need help with the basis of naturalization?',
            message: 'Provide the basis of naturalization',
            note: '',
          },
          derived: {
            title: 'Need help with the basis of derived citizenship?',
            message: 'Provide the basis of the derive citizenship',
            note: '',
          },
        },
        permanentresidentcardnumber: {
          title: 'Need help with your permanent resident card?',
          message: 'Provide your permanent resident card number',
          note: '',
        },
        residencestatus: {
          title: 'Need help with your residence status?',
          message: 'Provide your residence status',
          note: '',
        },
        documentexpiration: {
          title: 'Need help with the documentation expiration date?',
          message: 'Provide the approximate date of expiration',
          note: '',
        },
        documenttype: {
          title: 'Need help with the type of documentation?',
          message: 'Provide the type of documentation',
          note: '',
        }
      }
    },
    additional: {
      heading: {
        title: 'Additional citizenships',
        subtitle: 'This section asks for information regarding any additional citizenships you currently hold or have previously held that you did not list above. These citizenships could be held at the same time as another citizenship (that is, simultaneously as in dual or multiple citizenships) or sequentially (one at a time).',
        hasadditional: 'Have you ever been a citizen of another country? (Answer "Yes" if you currently hold or have previously held a citizenship with a country you did not list in Section 3. Otherwise, answer "No".)',
        citizenship: {
          country: 'Provide country of citizenship.  Select one at a time. You will be provided the opportunity to report additional citizenships',
          period: 'When were you a citizen of this country?',
          dates:
            'Provide the date range that you held this citizenship, beginning with the date it was acquired through its termination or "Present," whichever is appropriate',
          how: 'How did you become a citizen of this country? (For example, by birth, applied for, or through your parents)',
          passport: 'Were you ever issued a passport by this country?',
          active: 'Is the passport still active?',
          foreignPassport: 'Have you ever had a foreign passport, identity card, or other similar document for international travel?',
          docIntentIntl: 'Do you intend to use this document for international travel?',
          docIntent: 'Do you intend to keep this document?',
          threatened: 'While traveling to, from, or within this country, were you threatened, coerced, or pressured in any way to cooperate with a foreign government official (such as from a foreign military, intelligence service, diplomatic service, security service, a militia, other defense force?)',
          infoGrab: 'While traveling to or within this country, were you contacted by, or in contact with anyone attempting to obtain classified information or unclassified, sensitive information?',
          interest: 'While traveling to, from, or within this country, did you have contact with anyone who had personal knowledge of or undue interest in you or your work?',
          securityIncidents: 'While traveling to, from, or within this country, did you have any incidents that were a potential security concern or considered suspicious activity, such as someone following you?',
          foreignContact: 'While traveling to, from, or within this country, did you have contact with any person who you know or suspect is involved or associated with a foreign military, intelligence service, diplomatic service, security service, militia, other defense force, or government agency?',
          policeEncounters: 'While traveling to, from, or within this country, did you have any encounters with the police?',
          searched: 'While traveling to, from, or within this country, were you questioned, searched, or otherwise detained by customs, security officials, or any other entity? (This does not include those conducted as part of the normal customs’ process.)',
          whyTravel: 'Why did you travel to this country?',
          lengthOfTrip: 'How long was this trip?',
          whenTraveled: 'When did you travel to this country?',
          countryTraveledTo: 'What country did you travel to?',
          usedForIntl: 'Have you ever used this document for international travel?',
          access: 'Do you have access to this document?',
          expirationDate: 'What is the expiration date of this document?',
          issueDate: 'What is the issue date of this document?',
          issueLocation: 'Where was this document issued?',
          nameUsed: 'What name is used on this document?',
          docNum: 'What is the document number?',
          foreignCountry: 'What country issued this passport, identity card, or other similar document for international travel?',
          other: 'Please Explain',
        },
      },
      label: {
        explain: 'Please explain.',
        citizenship: {
          appendLabelIntlDoc: 'Do you have another instance in which you used this document for international travel to report?',
          appendLabelForeignPassports: 'Do you have any additional Foreign passports?',
        },
      },
      collection: {
        citizenship: {
          additional: {
            title: 'Have you ever had a foreign passport, identity card, or other similar document for international travel?',
          },
          dnkLabel: 'I Don\'t Know',
          summary: {
            title: 'Summary of additional citizenships',
            item: 'Country',
            unknown: 'Provide citizenship details below',
          },
          appendTitle: 'Do you have another country of citizenship to report that you have not already reported on this form?',
          foreignAppendTitle: 'Do you have another foreign passport, identity card, or other similar document for international travel?',
          append: 'Add another citizenship',
        },
      },
      help: {
        hasmultiple: {
          title: 'Need help with additional citizenships?',
          message: 'If you have ever had a non-U.S. citizenship then select "yes"',
          note: '',
        },
        citizenship: {
          country: {
            title: 'Need help with the country?',
            message: 'Provide the country',
            note: '',
          },
          dates: {
            title: 'Tell us the full date range you held this citizenship',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          how: {
            title: 'Need help with the how you acquired this citizenship?',
            message: 'Provide the how you acquired this citizenship',
            note: '',
          },
        },
      },
    },
  },
  label: {
    notApplicable: 'Not Applicable',
    or: 'or',
  },
  tour: {
    para: 'Take a guided tour through the section',
  },
  review: {
    para: 'View all the sections associated with citizenship at once',
  },
  section: {
    name: 'Citizenship',
  },
  subsection: {
    intro: 'Introduction',
    usPassport: 'U.S. passport information',
    status: 'Citizenship status',
    multiple: 'Dual/multiple citizenship',
    additional: 'Additional citizenships',
    passports: 'Foreign passports',
    review: 'Review',
  },
  comments: {
    branch: 'Optional Comment',
    optional: 'Optional Comment',
    summary: 'Optional Summary Comment'
  },
  destination: {
    intro: 'Citizenship intro',
    review: 'Review citizenship',
    passport: 'U.S. passport information',
    status: 'Citizenship status',
    multiple: 'Dual/multiple citizenship',
    passports: 'Foreign passports',
    additional: 'Additional citizenships',
  },
  errors: {
    missingRequiredDocumentsSF852013: {
      title: 'Citizenship Documents',
      message: 'At least one of the following documents are required: Certificate of Naturalization, Certificate of Citizenship, State Department Form 240, or US Passport'
    },
    alienregistrationexpiration: {
      tooearly: {
        title: 'Document Expiration Date',
        message: 'Visa document expiration is too early',
      },
    }
  },
  usPassport: {
    title: 'U.S. passport information',
    info: {
      text:
        'Provide the following information for the most recent U.S. passport you currently possess.',
      link: 'U.S. State Department passport help',
    },
    question: {
      title: 'Do you possess a U.S. passport (current or expired)?',
      yes: 'Yes',
      no: 'No',
    },
    label: {
      bookNumber: 'Passport number',
      book: 'Passport',
    },
    name: 'Provide the name in which passport was first issued',
    number: 'Provide your U.S. passport number',
    issued: 'Provide the issue date of the passport',
    expiration: 'Provide the expiration date of the passport',
    help: {
      number: {
        title: 'Passport',
        message:
          'U.S. Passport numbers must be nine alphanumeric characters (letters and numbers).',
        note: '',
      },
      issued: {
        title: 'Use the exact date',
        message: 'Enter the date on your passport.',
        note: '',
      },
      expiration: {
        title: 'Use the exact date',
        message: 'Enter the date on your passport.',
        note: '',
      },
    },
    branch: {
      help: {
        title: 'Need more information about the U.S. passport?',
        message: 'Select whether you possess a U.S. passport',
        note: '',
      },
    },
    names: {
      reuse: 'Choose a previously used name',
    },
  },
  status: {
    heading: {
      title: 'Citizenship status',
      citizenshipstatus: 'Select the box that reflects your current citizenship status',
      citizenshipstatusLabel: 'Provide your current citizenship status',
      abroad: 'Provide type of documentation of U.S. citizen born abroad',
      documentnumber: {
        foreignborn: 'Provide document number for U.S. citizen born abroad',
        notcitizen: 'Provide document number',
      },
      documentissued: 'Provide the date the document was issued',
      placeissued: 'Provide the place of issuance',
      documentname: 'Provide the name in which document was issued',
      certificatenumber: {
        foreignborn: 'Provide your Certificate of Citizenship number',
        naturalized: 'Provide your Certificate of Naturalization number (N550 or N570)',
        derived: 'Provide your Certificate of Citizenship number (N560 or N561)',
      },
      certificateissued: {
        foreignborn: 'Provide the date the certificate was issued',
        naturalized: 'Provide the date the Certificate of Naturalization was issued',
        derived: 'Provide the date the document was issued',
      },
      certificatename: {
        foreignborn: 'Provide the name in which the certificate was issued',
        naturalized: 'Provide the name in which the Certificate of Naturalization was issued',
        derived: 'Provide the name in which the document was issued',
        mothermaiden: 'Provide mother\'s maiden name'
      },
      certificatecourtname:
        'Provide the name of the court that issued the Certificate of Naturalization',
      certificatecourtaddress:
        'Provide the address of the court that issued the Certificate of Naturalization',
      bornonmilitaryinstallation: 'Were you born on a U.S. military installation?',
      militarybase: 'Provide the name of the base',
      entrydate: 'Provide the date of entry into the U.S.',
      entrylocation: 'Provide your place of entry in the U.S.',
      foreignBorn: {
        citizenship: 'Certificate of Citizenship',
        document: 'Document Information',
      },
      priorcitizenship: {
        naturalized: 'Provide country(ies) of prior citizenship',
        notcitizen: 'Provide your country(ies) of citizenship',
      },
      hasalienregistration: 'Do/did you have a U.S. alien registration number?',
      alienregistrationnumber: {
        naturalized:
          'Provide your U.S. alien registration number on Certificate of Naturalization-utilize USCIS, CIS, or INS registration, I-551, I-766',
        derived:
          'Provide your alien registration number (on Certificate of Citizenship - utilize USCIC, CIS, or INS registration number)',
        notcitizen: 'Provide your alien registration number (I-551, I-766)',
      },
      alienregistrationexpiration: 'Provide document expiration date',
      basis: {
        naturalized: 'Provide the basis of naturalization',
        derived: 'Provide the basis of derived citizenship',
      },
      permanentresidentcardnumber: 'Provide your Permanent Resident Card number (I-551)',
      residencestatus: 'Provide your residence status',
      documentexpiration: 'Provide document expiration date (I-776 ONLY)',
      documenttype: 'Provide type of document issued',
      maidenName: "Provide your mother's maiden name",
      form240date: 'Provide the date your State Department Form 240 was prepared',
      form240DateExplanation: 'Provide the explanation for the State Department Form 240',
      naturalized: {
        citizenship: 'Certificate of Citizenship',
        naturalization: 'Certificate of Naturalization',
        form240: 'State Department Form 240'
      }
    },
    label: {
      explanation: 'Explanation',
      citizenshipstatus: {
        citizen:
          'I am a U.S. citizen or national by birth in the U.S. or U.S. territory/commonwealth',
        foreignborn:
          'I am a U.S. citizen or national by birth, born to U.S. parent(s), in a foreign country',
        foreignborn2013: 'I am a U.S. citizen, but I was NOT born in the U.S.',
        naturalized: 'I am a naturalized U.S. citizen',
        derived: 'I am a derived U.S. citizen',
        notcitizen: 'I am not a U.S. citizen',
      },
      abroad: {
        fs240: 'FS-240',
        ds1350: 'DS-1350',
        fs545: 'FS-545',
        other: 'Other',
      },
      basis: {
        naturalized: 'Based on my own individual naturalization application',
        derived: 'By operation of law through my U.S. citizen parent',
        other: 'Other',
      },
      documenttype: {
        i94: 'I-94',
        visa: 'U.S. Visa (red foil number)',
        i20: 'I-20',
        ds2019: 'DS-2019',
        other: 'Other',
      },
    },
    help: {
      citizenshipstatus: {
        title: 'Need help with your citizenship status?',
        message: 'Select the box that reflects your current citizenship status',
        note: '',
      },
      abroad: {
        title: 'Need help with documentation of U.S. citizen born abroad?',
        message: 'Select the type of documentation',
        note: '',
      },
      documentnumber: {
        title: 'Need help with the document number?',
        message: 'Provide the document number',
        note: '',
      },
      documentissued: {
        title: 'Need help with the date the documentation was issued?',
        message: 'Provide the approximate date the documenation was issued',
        note: '',
      },
      placeissued: {
        title: 'Need help with the place the documentation was issued?',
        message: 'Provide the place where the documentation was issued',
        note: '',
      },
      documentname: {
        title: 'Need help with the name on the documentation?',
        message: 'Provide the name on the documentation',
        note: '',
      },
      certificatenumber: {
        title: 'Need help with the certificate number?',
        message: 'Provide the certificate number',
        note: '',
      },
      certificateissued: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      certificatename: {
        title: 'Need help with the name on the certificate?',
        message: 'Provide the name on the certificate',
        note: '',
      },
      bornonmilitaryinstallation: {
        title: 'Need help with if you were born on a military installation?',
        message: 'If you were born on a military installation select "yes"',
        note: '',
      },
      militarybase: {
        title: 'Need help with military base?',
        message: 'Provide the name of the military base',
        note: '',
      },
      entrydate: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      entrylocation: {
        title: 'Need help with the location of entry?',
        message: 'Provide the location of entry in to the U.S.',
        note: '',
      },
      priorcitizenship: {
        title: 'List all your prior citizenship(s)',
        message:
          'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
        note: '',
      },
      hasalienregistration: {
        title: 'Need help if you have an alien registration number?',
        message: 'If you have an alien registration number select "Yes"',
        note: '',
      },
      alienregistrationnumber: {
        title: 'Need help with your alien registration number?',
        message: 'Provide the alien registration number',
        note: '',
      },
      alienregistrationexpiration: {
        title: 'Need help with your alien registration expiration date?',
        message: 'Provide the date of expiration for the alien registration',
        note: '',
      },
      certificatecourtname: {
        title: 'Need help with the court name?',
        message: 'Provide the court name',
        note: '',
      },
      certificatecourtaddress: {
        title: 'Try looking up the court name, this could help you find the address',
        message: 'If you can only find a phone number try calling and asking for the address.',
        note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
      },
      basis: {
        naturalized: {
          title: 'Need help with the basis of naturalization?',
          message: 'Provide the basis of naturalization',
          note: '',
        },
        derived: {
          title: 'Need help with the basis of derived citizenship?',
          message: 'Provide the basis of the derive citizenship',
          note: '',
        },
      },
      permanentresidentcardnumber: {
        title: 'Need help with your permanent resident card?',
        message: 'Provide your permanent resident card number',
        note: '',
      },
      residencestatus: {
        title: 'Need help with your residence status?',
        message: 'Provide your residence status',
        note: '',
      },
      documentexpiration: {
        title: 'Need help with the documentation expiration date?',
        message: 'Provide the approximate date of expiration',
        note: '',
      },
      documenttype: {
        title: 'Need help with the type of documentation?',
        message: 'Provide the type of documentation',
        note: '',
      },
    },
  },
  multiple: {
    heading: {
      title: 'Dual/multiple citizenship',
      hasmultiple: 'Do you now or have you EVER held dual/multiple citizenships?',
      citizenship: {
        country: 'Provide country of citizenship',
        period: 'During what period of time did you hold citizenship with this country?',
        dates:
          'Provide the date range that you held this citizenship, beginning with the date it was acquired through its termination or "Present," whichever is appropriate',
        how: 'How did you acquire this non-U.S. citizenship you now have or previously had?',
        renounced: 'Have you taken any action to renounce your foreign citizenship?',
        renouncedexplanation: 'Provide explanation',
        current: 'Do you currently hold citizenship with this country?',
        currentexplanation: 'Provide explanation',
      },
      hasforeignpassport:
        'Have you EVER been issued a passport (or identity card for travel) by a country other than the U.S.?',
      passport: {
        title: 'Foreign passport information',
        country: 'Provide the country in which the passport (or identity card) was issued',
        issued: 'Provide the date the passport (or identity card) was issued',
        location: 'Provide the place the passport (or identity card) was issued',
        name: 'Provide the name in which passport (or identity card) was issued',
        number: 'Provide the passport (or identity card) number',
        expiration: 'Provide the passport (or identity card) expiration date',
        used: 'Have you EVER used this passport (or identity card) for foreign travel?',
      },
      travel: {
        country: 'Provide the country to which you traveled on this passport (or identity card)',
        dates: 'Provide the dates involved',
      },
    },
    collection: {
      citizenship: {
        summary: {
          title: 'Summary of dual/multiple citizenships',
          item: 'Country',
          unknown: 'Provide citizenship details below',
        },
        appendTitle: 'Do you have an additional citizenship to provide?',
        append: 'Add another citizenship',
      },
      passport: {
        summary: {
          title: 'Summary of foreign passports',
          item: 'Country',
          unknown: 'Provide passport details below',
        },
        appendTitle: 'Do you have an additional foreign passport (or identity card) to report?',
        append: 'Add another foreign passport',
      },
      travel: {
        summary: {
          title: 'Summary of foreign travel',
          item: 'Country',
          unknown: 'Provide travel details below',
        },
        append: 'Add another foreign travel',
      },
    },
    help: {
      hasmultiple: {
        title: 'Need help with multiple citizenships?',
        message: 'If you have ever had a non-U.S. citizenship then select "yes"',
        note: '',
      },
      citizenship: {
        country: {
          title: 'Need help with the country?',
          message: 'Provide the country',
          note: '',
        },
        dates: {
          title: 'Tell us the full date range you held this citizenship',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        how: {
          title: 'Need help with the how you acquired this citizenship?',
          message: 'Provide the how you acquired this citizenship',
          note: '',
        },
        renounced: {
          title: 'Need help with the renouncement?',
          message: 'If you have renounced this citizenship select "yes"',
          note: '',
        },
        renouncedexplanation: {
          title: 'Need help explaining your renouncement?',
          message: 'Provide the explanation for the renouncement',
          note: '',
        },
        current: {
          title: 'Need help with the current citizenship?',
          message: 'If you still retain citizenship select "yes"',
          note: '',
        },
        currentexplanation: {
          title: 'Need help explaining your current citizenship?',
          message: 'Provide the explanation for the current citizenship',
          note: '',
        },
      },
      hasforeignpassport: {
        title: 'Need help with foreign passports or identity cards?',
        message: 'If you have ever had a foreign passport or identity card then select "yes"',
        note: '',
      },
      passport: {
        country: {
          title: 'Need help with the country?',
          message: 'Provide the country',
          note: '',
        },
        issued: {
          title: 'Need help with the dates issued?',
          message: 'Provide the approximate date the item was issued',
          note: '',
        },
        location: {
          title: 'Need help with the place it was issued?',
          message: 'Provide the location the passport (or identity card) was issued',
          note: '',
        },
        name: {
          title: 'Need help with the name?',
          message: 'Provide the name on the passport (or identity card)',
          note: '',
        },
        number: {
          title: 'Need help with the passport number?',
          message: 'Provide the passport (or identity card) number',
          note: '',
        },
        expiration: {
          title: 'Need help with the expiration date?',
          message: 'Provide the approximate date the item expires',
          note: '',
        },
        used: {
          title: 'Need help determining if the passport was used?',
          message: 'If you have used the passport for travel then select "yes"',
          note: '',
        },
      },
      travel: {
        country: {
          title: 'Need help with the country?',
          message: 'Provide the country',
          note: '',
        },
        dates: {
          title: 'Not sure of the exact dates?',
          message: 'Give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
      },
    },
  },
};
